<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{'stores' | translate}}</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
            </div>
          </div>
          <div class="box-controls">
            <div class="btn-group">
              <button type="button" class="btn btn-default btn-sm" data-toggle="collapse" data-target="#coll1" aria-expanded="false" aria-controls="coll1">
                <i class="fa fa-sort mr-5"></i>{{'filter_stores' | translate}}
              </button>
            </div>
            <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
            <div class="row">
              <div class="col-xs-12">
                <div class="collapse in" id="coll1">
                  <div class="pt-10 row pb-10 ">
                    <div class="col-md-2 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">{{'status' | translate | capitalize}}:</div>
                        <select class="form-control" v-model="isActive" @click.prevent="paginate('','')">
                          <option value="">{{'all' | translate | capitalize}}</option>
                          <option value="1">{{'is_active' | translate | capitalize}}</option>
                          <option value="0">{{'inactive' | translate | capitalize}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-2 col-sm-6">
                      <div class="input-group">
                        <div class="input-group-addon">{{'show' | translate | capitalize}}:</div>
                        <select id="count-select" class="form-control" v-model="count" @click.prevent="paginate('count','')">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>{{'status' | translate | capitalize}}</th>
                    <th>{{'name' | translate | capitalize}}</th>
                    <th>{{'street' | translate | capitalize}}</th>
                    <th>{{'zip_code' | translate | capitalize}}</th>
                    <th>{{'city' | translate | capitalize}}</th>
                    <th>{{'country' | translate | capitalize}}</th>
                    <th>{{'details' | translate | capitalize}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in pagination.data">
                    <td v-if="item.is_active === 1">
                      <span class="label label-success"><i class="fa fa-check mr-5"></i>{{'is_active' | translate}}</span>
                    </td>
                    <td v-else>
                      <span class="label label-danger"><i class="fa fa-ban mr-5 mr-5"></i>{{'inactive' | translate}}</span>
                    </td>
                    <td>{{item.name}}</td>
                    <td>{{item.street}}&nbsp;{{item.street_no}}</td>
                    <td>{{item.zip_code}}</td>
                    <td>{{item.city}}</td>
                    <td>{{item.country | country}}</td>
                    <td>
                      <a class="btn btn-info btn-block btn-sm" :href="`stores/${item.id}`">
                        <i class="fa fa-edit mr-5"></i>
                        {{'edit_store' | translate}}
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  // import $ from 'jquery'
  module.exports = {
    name: 'Tables',
    data () {
      return {
        serverURI: this.$parent.serverURI + 'accounting/stores',
        caller: this.$http,
        count: 25,
        stores: {},
        alerts: [],
        language: this.$store.getters.language,
        pagination: {
          total: 0,
          per_page: 25,
          current_page: 1,
          total_pages: 0
        },
        translate: this.$parent.translate,
        isActive: '',
        getStores (params) {
          API.get(`accounting/stores?${params}`)
            .then(response => {
              this.pagination = response.body
            })
            .catch(error => {
              if (this.$store.dispatch('checkError', error)) {
                let alert = {dismiss: 4, type: 'danger', message: this.translate(error.body.error_code) || error.body.error_message}
                this.$store.commit('pushAlert', alert)
              }
            })
        },
        checkToken () {
          return window.localStorage.getItem('token') == null ? '' : window.localStorage.getItem('token')
        },
        paginate (type, value) {
          let url = ''
          switch (type) {
            case 'count':
              url += `&count=${this.count}&page=1`
              break
            case 'page':
              url += '&page='
              if (value === 'previous') {
                url += (this.pagination.current_page - 1)
              }
              if (value === 'next') {
                url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
              } else if (value !== 'next' && value !== 'previous') {
                url += value
              }
              url += `&count=${this.count}`
              break
          }
          url += '&active=' + this.isActive
          this.getStores(url)
        }
      }
    },
    computed: {
      store () {
        return this.$parent.$store
      },
      isMobile () {
        return (window.innerWidth <= 800 && window.innerHeight <= 600)
      }
    },
    methods: {
      go() {
        this.$router.push('stores/create')
      },
      storeDelete(id) {
        API.delete(`accounting/stores/${id}`)
          .then(response => {
            this.paginate('', '')
            let alert = {
              dismiss: 4,
              type: 'warning',
              message: `Store with id: ${response.body.success} deleted successfully`
            }
            this.$store.commit('pushAlert', alert)
          })
          .catch(error => {
            if (this.$store.dispatch('checkError', error)) {
              let alert = {
                dismiss: 4,
                type: 'danger',
                message: this.translate(error.body.error_code) || error.body.error_message
              }
              this.$store.commit('pushAlert', alert)
            }
          })
      }
    },
    mounted () {
      this.$nextTick(() => {
        API.get('accounting/stores', {})
          .then(response => {
            this.pagination = response.body
          })
          .catch(error => {
          this.checkError(error)
        })
      })
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/Stores.vue